LogoutServices.$inject = ["$resource", "$auth"];

function LogoutServices($resource, auth) {
    let user = auth.user() || { auth_token: null };
    
    return $resource(`${gateway}/:type/:id`, {
        id: '@id',
        type: '@type'
    }, {

        query: {
            method: "GET",
            isArray: true
        },

        create: {
            method: "POST"
        },

        get: {
            method: "GET",
            headers: {
                'Authorization': 'Bearer ' + user.auth_token
            },
        },

        remove: {
            method: "DELETE"
        },

        update: {
            method: "PUT"
        }

    });

}

module.exports = ngModule => {

    ngModule.factory('Authentication.LogoutServices', LogoutServices);

};